var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button button_auxilliary",class:(_vm.wrapper + "__share"),on:{"click":function($event){return _vm.managePopupState({ popup: 'sharer', _state: true })}}},[_c('span',[_vm._v(_vm._s(_vm.$t("VUE.SHARE"))+" :")]),_c('div',{staticClass:"button__icons"},_vm._l((_vm.icons),function(ref,index){
var src = ref.src;
var alt = ref.alt;
return _c('img',{key:(src + "_" + index),attrs:{"src":src,"alt":alt}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }